import { initializeApp } from "firebase/app";
import { getMessaging, getToken } from "firebase/messaging";

import { FIREBASE_CONFIG, VAPID_KEY } from "./constants/firebase";

const app = initializeApp(FIREBASE_CONFIG);
const messaging = getMessaging(app);

export async function getDeviceToken(retryCount = 0) {
  try {
    const deviceToken = await getToken(messaging, { vapidKey: VAPID_KEY });
    return deviceToken;
  } catch (err) {
    if (retryCount < 5) {
      // many trials to generate FCM ID token
      return await getDeviceToken(retryCount + 1);
    } else {
      return null;
    }
  }
}

export const getFirebaseMessagingInstance = async () => {
  return getMessaging(app);
};
